import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export default function QuestionTimeDedicationPage() {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    navigate('/onboarding/question-plant-types-interest')
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.questionTimeDedication.heading')}
      buttons={[
        {
          text: t('pages.onboarding.questionTimeDedication.lessThan30'),
          value: 'less_than_30',
        },
        {
          text: t('pages.onboarding.questionTimeDedication.thirtyToHour'),
          value: '30_to_hour',
        },
        {
          text: t('pages.onboarding.questionTimeDedication.oneToTwo'),
          value: '1_to_2',
        },
        {
          text: t('pages.onboarding.questionTimeDedication.twoPlus'),
          value: '2_plus',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
